export default "__VITE_ASSET__4f9f9488__"